import { render, staticRenderFns } from "./Photo.vue?vue&type=template&id=2d4e57ee&scoped=true&"
import script from "./Photo.vue?vue&type=script&lang=js&"
export * from "./Photo.vue?vue&type=script&lang=js&"
import style0 from "./Photo.vue?vue&type=style&index=0&id=2d4e57ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4e57ee",
  null
  
)

export default component.exports